import React, { useState, useEffect } from 'react';

// NotFoundPage Component
const NotFoundPage = () => {
  const goHome = () => {
    window.location.href = '/dashboard';
  };

  const goBack = () => {
    window.history.back();
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full text-center">
        <div className="mb-8">
          <div className="mx-auto h-24 w-24 bg-blue-100 rounded-full flex items-center justify-center">
            <svg className="h-12 w-12 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.172 16.172a4 4 0 015.656 0M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
        </div>
        
        <h1 className="text-6xl font-bold text-gray-900 mb-4">404</h1>
        <h2 className="text-2xl font-semibold text-gray-700 mb-4">
          Pagina nu a fost găsită
        </h2>
        <p className="text-gray-600 mb-8">
          Ne pare rău, dar pagina pe care o căutați nu există sau a fost mutată.
        </p>
        
        <div className="space-y-3 sm:space-y-0 sm:space-x-3 sm:flex sm:justify-center">
          <button
            onClick={goBack}
            className="w-full sm:w-auto px-6 py-3 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition-colors"
          >
            Înapoi
          </button>
          <button
            onClick={goHome}
            className="w-full sm:w-auto px-6 py-3 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
          >
            Acasă
          </button>
        </div>
        
        <div className="mt-8 pt-8 border-t border-gray-200">
          <p className="text-sm text-gray-500">
            Dacă problema persistă, vă rugăm să contactați administratorul.
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;